/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { JobScheduleListItemDto, SalesScheduleListItemDto } from '@gh/builder-shared-data';

export type JobScheduleFinderListItem = JobScheduleListItemDto;
export type SalesScheduleFinderListItem = SalesScheduleListItemDto;
export type ScheduleFinderListItem = JobScheduleFinderListItem | SalesScheduleFinderListItem;

export const getScheduleFinderListItemId = (item: ScheduleFinderListItem) => item.scheduleId;
